const FALLBACK_LOCALE = 'en-US';

/**
 * A BCP-47 locale tag that is always safe to pass to an Intl constructor. Chromium on
 * POSIX-locale CI runners reports non-BCP-47 tags such as "en-US@posix" for navigator.language,
 * and the Intl constructors throw RangeError on them — which, when a module builds a formatter at
 * import time, crashes every module that imports it. Drop the POSIX "@modifier", canonicalize,
 * and fall back to en-US if the tag is still unusable.
 */
export function getUserLocale(): string {
  const base = (navigator.language || FALLBACK_LOCALE).split('@')[0];
  try {
    return Intl.getCanonicalLocales(base)[0] ?? FALLBACK_LOCALE;
  } catch {
    return FALLBACK_LOCALE;
  }
}

const INTL_FALLBACK_LANGUAGE = 'en';
const LANGUAGE_REGION_SEPARATOR = /_/g;

/** An i18next language ("zh_CN") as an Intl locale ("zh-CN"), or English when it is not one Intl knows. */
export function getIntlLocale(language: string = window.i18next.language): string {
  try {
    return Intl.getCanonicalLocales(language.replace(LANGUAGE_REGION_SEPARATOR, '-'))[0] ?? INTL_FALLBACK_LANGUAGE;
  } catch {
    return INTL_FALLBACK_LANGUAGE;
  }
}
